import { useUser } from "hooks/use-user";
import DispatcherAllTicketsList from "./dispatcherTickets/all-tickets-list";
import CCAAllTicketsList from "./callCenterAgentTickets/all-tickets-list";
import { isCallCenterAgent } from "./utils";
// import DispatcherAllTicketsListV2 from "./dispatcherTickets/all-tickets-list-v2";

export default function AllTicketsList() {
  const user = useUser();
  const isCCA = isCallCenterAgent(user);

  if (isCCA) {
    return <CCAAllTicketsList />;
  }
  return <DispatcherAllTicketsList />;
}
